import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewInsumoComercial = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'insumo_comercial',
        name: 'Insumo Comercial',
        component: ViewInsumoComercial,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
